import React from "react";
import PropTypes from "prop-types";
import { Button, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

/** Shared documents block (instructions + upload) for bond cancellation dialogs. */
export default function BondDialogDocumentsSection({
  bond,
  getCancellationInstructionsList,
  cancellationFile,
  disableUpload,
  onFileInputChange,
  uploadButtonLabel = "Choose File",
}) {
  if (!bond) return null;

  return (
    <>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5 }}>
        Documents
      </Typography>
      <Typography variant="subtitle2" sx={{ fontWeight: 500, mb: 1 }}>
        Acceptable Documentation:
      </Typography>
      <ul
        style={{
          paddingLeft: "24px",
          marginBottom: "20px",
          listStyleType: "disc",
        }}
      >
        {getCancellationInstructionsList(bond).map((item, idx) => (
          <li
            key={`cancellation-doc-${idx}-${item}`}
            style={{ fontSize: "0.9rem", marginBottom: "6px" }}
          >
            {item}
          </li>
        ))}
      </ul>

      <Button
        variant="outlined"
        component="label"
        disabled={disableUpload}
        startIcon={<CloudUploadIcon />}
        sx={{ mb: 2 }}
      >
        {uploadButtonLabel}
        <input
          type="file"
          hidden
          accept=".pdf,.doc,.docx"
          onChange={onFileInputChange}
        />
      </Button>
      {cancellationFile && (
        <Typography variant="caption" sx={{ display: "block", mb: 2 }}>
          Selected File: {cancellationFile.name}
        </Typography>
      )}
    </>
  );
}

BondDialogDocumentsSection.propTypes = {
  bond: PropTypes.object,
  getCancellationInstructionsList: PropTypes.func.isRequired,
  cancellationFile: PropTypes.object,
  disableUpload: PropTypes.bool,
  onFileInputChange: PropTypes.func.isRequired,
  uploadButtonLabel: PropTypes.string,
};
